/* jshint esversion: 6 */
import React from 'react';
import classnames from 'classnames';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import DropDownModule from 'app/mixins/DropDownModule.js';
import * as IconFactory from 'app/components/common/IconFactory.jsx';
import { Link } from 'react-router-dom';
import FormattedRelativeWrapper from 'app/components/common/FormattedRelativeWrapper.jsx';
import { compose } from 'redux';

class NotificationItem extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isHovering: false
		};

		this.onMouseOver = this.onMouseOver.bind(this);
		this.onMouseOut = this.onMouseOut.bind(this);
		this.removeNotice = this.removeNotice.bind(this);

	}

	onMouseOver(e) {
		this.setState({
			isHovering: true
		});
	}

	onMouseOut(e) {
		this.setState({
			isHovering: false
		});
	}

	removeNotice(e) {

		e.preventDefault();
		e.stopPropagation();
		this.props.clearNotices({
			hash: this.props.item.hash
		});

	}

	render() {
		let time = null,
			action = null,
			Icon = null,
			social = null,
			iconState = "",
			iconInactive = false,
			iconType = this.props.item.type,
			itemClass = classnames('notification-item',
				{
					'active-item': this.props.itemActive
				}
			),
		    messageExtra = null,
			constants = this.props.app.config.constants,
			message = this.props.item.message;

		time = moment(this.props.item.ts).unix() * 1000;

		if (this.props.item.entityType === 'output') {
			Icon = IconFactory[ConstantMixin.getIconIndexByCode(this.props.item.entityTypeId)];
			if (this.props.item.code && this.props.item.code == "2004") {
                action = <Link to={'/queue/detail/' + this.props.item.entityId} onClick={() => { this.props.resetHandler('notices'); }}>View queue</Link>;
            } else if (this.props.item.code == "2013") {
				if (this.props.item.entityTypeId !== constants.POST_SVC_TWITTER) {
					action = <Link to="/account/subscription/new?utm_source=basic.limit&utm_medium=notices" onClick={() => { this.props.resetHandler('notices'); }}>Get unlimited posting</Link>;
				}
				messageExtra = <Link style={{'float':'right'}} className="grey-link" to={'/config/social/' + this.props.item.entityId + '/log'} onClick={() => { this.props.resetHandler('notices'); }}>Details</Link>;
            } else {
				social = this.props.findSocial(this.props.item.entityId);
				if (social) {
					if (parseInt(social.activeFlag, 10)) {
						action = <span></span>;
						iconType = 0;
					} else {
						iconInactive = true;
						action = <Link to={'/config/socials/detail/' + this.props.item.entityId} onClick={() => { this.props.resetHandler('notices'); }}>Reconnect</Link>;
					}
				}
				else {
					iconInactive = true;
				}
			}
		} else if (this.props.item.entityType === 'output-client') {
			Icon = IconFactory[ConstantMixin.getIconIndexByCode(this.props.item.entityTypeId)];
			action = <span></span>;
		} else if (this.props.item.entityType === 'shortener') {
			Icon = IconFactory[ConstantMixin.getIconIndexByCode(this.props.item.entityTypeId, this.props.item.entityType)];
			social = this.props.findSocial(this.props.item.entityId);
			if (social) {
				if(social.activeFlag) {
					action = <span></span>;
					iconType = 0;
				} else {
					action = <Link to={'/config/socials/detail/' + this.props.item.entityId} onClick={() => { this.props.resetHandler('notices'); }}>Reconnect</Link>;
				}
			}
		} else if (this.props.item.entityType === 'input') {
			if (this.props.item.entitySubtype) {
				Icon = IconFactory[ConstantMixin.getIconIndexByCode(this.props.item.entitySubtype)];
			} else {
				Icon = IconFactory[ConstantMixin.getIconIndexByCode(this.props.item.entityTypeId)];
			}
			if (this.props.item.routeId) {
				action = <Link to={'/share/automate/detail/' + this.props.item.routeId + '/input/' + this.props.item.entityId + '/status'} onClick={() => { this.props.resetHandler('notices'); }}>View log</Link>;
			}
		} else if (this.props.item.entityType === 'publisher') {
			Icon = IconFactory[ConstantMixin.getIconIndexByCode(null, this.props.item.entityType)];
			if (this.props.item.code) {
				if (this.props.item.code == "1001") {
					action = <a href="/bulkauth.php">Bulk authorization</a>;
				} else if (this.props.item.code == "1002") {
					action = <Link to="/config/socials" onClick={() => { this.props.resetHandler('notices'); }}>View socials</Link>;
				}
			} else {
				action = <Link to="account" onClick={() => { this.props.resetHandler('notices'); }}>View settings</Link>;
			}
		}


		if (this.state.isHovering || iconType === 0) {
			iconState = (<i className="fa fa-times notification-remove" onClick={this.removeNotice}></i>);
		} else {
			if (iconType === "10") {
				iconState = (<i className="fa fa-exclamation-circle notification-item-terminal"></i>);
			} else {
				iconState = (<i className="fa fa-exclamation-triangle notification-item-warning"></i>);
			}
		}

		return (
			<li key={this.props.item.entityId} className={itemClass}>
				<div className="notification-item-header" onMouseOver={this.onMouseOver} onMouseOut={this.onMouseOut}>
					<div className="notification-item-header-date">
						<FormattedRelativeWrapper value={time} />
					</div>
					<div className="notification-item-header-actions">
						{ action }
						{ iconState }
					</div>
				</div>
				<div className="notification-item-trigger">
					<div className="trigger-icon">
						<Icon inactive={iconInactive} />
					</div>
					{ this.props.item.entityName }
				</div>
				<div className="notification-item-notice">
					{ messageExtra } { message }
				</div>
			</li>
		);
	}
};

const enhance = compose(
	DropDownModule
);

export default enhance(NotificationItem);
